import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  UpdateTeamDefaultSearchTopicMutation,
  UpdateTeamDefaultSearchTopicMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const updateTeamDefaultSearchTopic = graphql(`
  mutation updateTeamDefaultSearchTopic($input: UpdateTeamDefaultSearchTopicInput!) {
    updateTeamDefaultSearchTopic(UpdateTeamDefaultSearchTopicInput: $input) {
      defaultSearchTopic
    }
  }
`);

export function useUpdateTeamDefaultSearchTopic(
  options?: UseMutationOptions<
    UpdateTeamDefaultSearchTopicMutation,
    unknown,
    UpdateTeamDefaultSearchTopicMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { data, ...rest } = useGraphQlMutation(updateTeamDefaultSearchTopic, {
    ...options,
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries(["team"]);
      options?.onSuccess?.(data, variables, context);
    },
  });

  return { data: data?.updateTeamDefaultSearchTopic, ...rest };
}
